module.exports = __webpack_public_path__ + "fa-brands-400.592643a83b8541edc520.eot";


//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/@fortawesome/fontawesome-free/webfonts/fa-brands-400.eot
// module id = ../../../../@fortawesome/fontawesome-free/webfonts/fa-brands-400.eot
// module chunks = 2